var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"400px","margin-top":"10px","border":"3px solid lightgray"}},[_c('map-base',{ref:"mapBase",attrs:{"invalidate-map-size":_vm.invalidateMapSize,"map-options":{ doubleClickZoom: false }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }